import {
  PencilIcon_default
} from "./chunk-F53VBGTD.mjs";
export {
  PencilIcon_default as default
};
